import { render } from "./period-scope-for-update-modal.vue?vue&type=template&id=90bd5ed1"
import script from "./period-scope-for-update-modal.vue?vue&type=script&lang=js"
export * from "./period-scope-for-update-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__